import React from 'react';
import { TouchableOpacity } from 'react-native';
import { Sun, Moon } from 'lucide-react-native';
import {  useThemeName, Text } from '@tamagui/core';
import { XStack } from '@tamagui/stacks';

interface ThemeSwitcherProps {
  onToggle: () => void;
}

const ThemeSwitcher: React.FC<ThemeSwitcherProps> = ({ onToggle }) => {
  const themeName = useThemeName();
  const isDark = themeName === 'dark';

  const backgroundColor = themeName === 'dark' ? '#374151' : '#f3f4f6';
  const borderColor = themeName === 'dark' ? '#4b5563' : '#d1d5db';
  const textColor = themeName === 'dark' ? '#ffffff' : '#374151';
  const iconColor = themeName === 'dark' ? '#fbbf24' : '#6b7280';

  return (
    <TouchableOpacity onPress={onToggle}>
      <XStack
        alignItems="center"
        paddingHorizontal="$3"
        paddingVertical="$2"
        borderRadius="$4"
        backgroundColor={backgroundColor}
        borderWidth={1}
        borderColor={borderColor}
        space="$2"
      >
        {isDark ? (
          <Sun size={16} color={iconColor} />
        ) : (
          <Moon size={16} color={iconColor} />
        )}
        <Text fontSize="$3" color={textColor} fontWeight="600">
          {isDark ? 'Light' : 'Dark'}
        </Text>
      </XStack>
    </TouchableOpacity>
  );
};

export default ThemeSwitcher;
